module.exports = __webpack_public_path__ + "media/images/logo-5d6a3cdbbb1b23d1f5abeb6dd57bad3c.svg";